import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  Modal,
  Button,
} from "react-bootstrap";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import {
  RiSparkling2Fill,
  RiSparklingFill,
} from "react-icons/ri";

import styles from "./BasicDetails.module.css";

const BasicDetails = () => {
  const [show, setShow] = useState(false);

  const [selectedFields, setSelectedFields] =
    useState({
      shortDescription: true,
      productCode: false,
      variants: false,
    });

  const [keywords, setKeywords] = useState("");

  const handleCheckbox = (field) => {
    setSelectedFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const generateKeywords = () => {
    const keywordList = [];

    if (selectedFields.shortDescription) {
      keywordList.push("short description");
    }

    if (selectedFields.productCode) {
      keywordList.push("product code");
    }

    if (selectedFields.variants) {
      keywordList.push("variants");
    }

    setKeywords(keywordList.join(", "));
    setShow(false);
  };

  return (
    <>
      <Row className="g-3">
        {/* Short Description */}
        <Col lg={6}>
          <Form.Group>
            <Form.Label className={styles.label}>
              Short Description
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Enter short description"
              className={styles.textarea}
            />
          </Form.Group>
        </Col>

        {/* Keywords */}
        <Col lg={6}>
          <Form.Label className={styles.label}>
            Key Words For Search
          </Form.Label>

          <div className={styles.keywordWrapper}>
            <Form.Control
              as="textarea"
              rows={4}
              value={keywords}
              placeholder="shoe, nike, sport..."
              className={styles.textarea}
              onChange={(e) =>
                setKeywords(e.target.value)
              }
            />

            <button
              className={styles.aiBtn}
              onClick={() => setShow(true)}
              type="button"
            >
              
              <RiSparklingFill size={12} />
              AI
            </button>
          </div>
        </Col>

        {/* About Product */}
        <Col lg={12}>
          <Form.Group>
            <Form.Label className={styles.label}>
              About Product Item
            </Form.Label>

            <div className={styles.editorWrapper}>
              <ReactQuill theme="snow" />
            </div>
          </Form.Group>
        </Col>
      </Row>

      {/* AI Modal */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        dialogClassName={styles.aiModal}
      >
        <Modal.Body className={styles.modalBody}>
          <div className={styles.modalTitle}>
            AI Key Words Generator
          </div>

          <div className={styles.checkList}>
            {/* Always Checked */}
            <label className={styles.checkItem}>
              <input
                type="checkbox"
                checked
                disabled
              />

              <span>Short Description</span>
            </label>

            <label className={styles.checkItem}>
              <input
                type="checkbox"
                checked={selectedFields.productCode}
                onChange={() =>
                  handleCheckbox("productCode")
                }
              />

              <span>Product Code</span>
            </label>

            <label className={styles.checkItem}>
              <input
                type="checkbox"
                checked={selectedFields.variants}
                onChange={() =>
                  handleCheckbox("variants")
                }
              />

              <span>Variants</span>
            </label>
          </div>

          <div className={styles.modalFooter}>
            <Button
              variant="light"
              size="sm"
              onClick={() => setShow(false)}
            >
              Cancel
            </Button>

            <Button
              size="sm"
              onClick={generateKeywords}
            >
              Apply
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BasicDetails;